<template>
	<section>
		<div v-if="!isDetailFormRoute">
			<v-layout align-center pl-5 pr-5 mt-4>
				<v-btn icon @click="goBack" class="mr-3">
					<v-icon>arrow_back</v-icon>
				</v-btn>
				<header-page
					name="promotion-details"
					:title="`Banners de la Promoción`"
				/>
			</v-layout>

			<div class="px-5 mt-4">
				<app-table 
					class="my-5 is-not-selectable pb-4" 
					name="promotion-details" 
					:columns="columns" 
					:current-page="currentPage"
					:rows="rows" 
					:last-page="lastPage" 
					@on-search-event="onSearch" 
					@on-page="changePage"
				>
					<template slot="rows" slot-scope="props">
						<td class="is-not-selectable" v-show="showRow(columns, 1)">
							{{ props.row.order }}
						</td>
						<td v-show="showRow(columns, 2)">
							<v-chip color="blue" text-color="white" small>
								{{ props.row.environment }}
							</v-chip>
						</td>
						<td v-show="showRow(columns, 3)">
							{{ props.row.resourceType }} 
						</td>
						<td v-show="showRow(columns, 4)">
							<a :href="props.row.fileUrl" target="_blank" v-if="props.row.fileUrl">Ver Recurso</a>
							<span v-else>N/A</span>
						</td>
						<td v-show="showRow(columns, 5)" class="d-flex align-center">
							<app-tooltip-button
								color="blue"
								icon="edit"
								text="Editar"
								@click-icon="edit(props.row)"
							/>
							<app-tooltip-button
								color="red"
								icon="delete"
								text="Eliminar"
								@click-icon="openModalConfirmation(props.row)"
							/>
						</td>
					</template>
				</app-table>
			</div>
			
			<quick-actions
				:actions="actions"
				@open-modal="openModal"
			>
			</quick-actions>
		</div>
		
		<app-confirmation-modal
			:loading="loading"
			:show-modal="modalConfirmation.value"
			@cancel="cancelModalConfirmation"
			@confirm="confirm()"
		/>
		<router-view></router-view>
	</section>
</template>

<script>
import quickActions from '@/components/shared/quick-actions';
import appTooltipButton from '@/components/shared/app-tooltip-button';
import appConfirmationModal from '@/components/shared/app-confirmation-modal';

function openModal() {
	this.goTo('page-new-promotion-detail', { params: { id: this.id } });
}

function edit({ id }) {
	// 'id' de la fila es el detailId, 'this.id' es el promotionId de la URL
	this.goTo('page-edit-promotion-detail', { params: { id: this.id, detailId: id } });
}

function goBack() {
	this.goTo('page-promotions');
}

async function confirm() {
	try {
		const headers = { Accept: `${process.env.ACCEPT_SERVICE_V2}` };
		await this.$http.delete(`promotion-detail/${this.modalConfirmation.selectedRow.id}`, { headers });
		this.showNotification('El detalle se eliminó correctamente');
		this.cancelModalConfirmation();
		this.loadData();
	} catch (error) {
		this.showError();
	}
}

async function loadData() {
	try {
		const params = { ...this.params };
		// Filtramos por la promoción actual (id viene por params de la ruta)
		params.promotionId = this.id;
		const headers = { Accept: `${process.env.ACCEPT_SERVICE_V2}` };
		const response = await this.$http.get('promotion-detail', { params, headers });
		this.rows = response.data.data;
		this.lastPage = Number(response.headers['x-last-page']);
	} catch (error) {
		this.showError();
	}
}

function changePage(page) {
	this.currentPage = page;
	this.params.page = page;
	this.loadData();
}

function onSearch(search) {
	this.params.search = search ? search.trim() : null;
	this.loadData();
}

function created() {
	this.loadData();
}

function data() {
	return {
		actions: [
			{
				id: 1,
				code: 'PROMO_DET',
				text: 'Agregar Detalle',
				img: '',
				active: true,
			},
		],
		columns: [
			{ id: 1, name: 'Orden', checked: true, visible: true },
			{ id: 2, name: 'Entorno', checked: true, visible: true },
			{ id: 3, name: 'Tipo', checked: true, visible: true },
			{ id: 4, name: 'Imagen / Archivo', checked: true, visible: true },
			{ id: 5, name: '', checked: true, visible: true, flagVisible: true },
		],
		currentPage: 1,
		lastPage: 0,
		rows: [],
		loading: false,
		params: {
			page: 1,
			promotionId: this.id,
		},
	};
}

export default {
	name: 'page-promotion-details',
	data,
	created,
	components: {
		appTooltipButton,
		quickActions,
		appConfirmationModal,
	},
	computed: {
		isDetailFormRoute() {
			return this.$route.name && (this.$route.name.includes('new-promotion-detail') || this.$route.name.includes('edit-promotion-detail'));
		},
	},
	methods: {
		openModal,
		edit,
		goBack,
		loadData,
		changePage,
		onSearch,
		confirm,
	},
	props: {
		id: {
			type: [Number, String], // ID de la promoción
		},
		codeProject: {
			type: String,
		},
	},
	watch: {
		$route(newVal) {
			if (newVal && newVal.name === 'page-promotion-details') {
				this.loadData();
			}
		},
		params: {
			handler(newVal) {
				if (newVal) this.loadData();
			},
			deep: true
		}
	},
};
</script>


// WEBPACK FOOTER //
// src/pages/promotions-details/page-promotion-details.vue